<template>
  <div class="container row">
    <div class="nav row">
      <div class="title">
        <div v-if="info">{{info.title}}</div>
      </div>
      <div class="oporation row" v-if="info">
        <div class="time">{{info.date}}</div>
        <div class="download" @click="download"></div>
        <div @click="onCollection" v-if="!info.collected" class="collection-img"></div>
        <div @click="onUncollect" class="collected-img" v-if="info.collected"></div>
        <!-- <div class="collection" :class="{'collected': info.collected}"></div> -->
      </div>
    </div>
    <div class="main row">
      <pdf class="pdf" v-if="info" :goToPage="goToPage" :go="go" :link="info.link" @pdfInitReady="pdfInitReady"></pdf>
      <div class="right" v-if="info&&info.text">
        <div v-if="keyWords&&keyWords.length&&keyWords[0]" class="search-nav row">
          搜索关键词：<span v-for="(item, index) in keyWords" :key="index+'keyword'">{{keyWords[index]}}&nbsp;</span>
        </div>
        <div class="search-items" v-if="info&&info.text">
          <div v-for="(item, index) in info.text" :key="index" class="item-container">
            <detail-search-item
              :keyWords="keyWords"
              :text="item.content"
              :page="item.page"
              @click.native="goToPdfPage(item.page)"
            ></detail-search-item>
          </div>
        </div>
      </div>
    </div>
    <PdfFooter></PdfFooter>
    <members-expire-dialog @close="membersExpiredDialogVisible=false" v-if="membersExpiredDialogVisible"></members-expire-dialog>
    <el-dialog
      title="选择收藏夹"
      class="collect-dialog"
      :visible.sync="collectDialogVisible"
      width="410px"
      >
      <div class="dialog-content">
        <input ref="input" @blur="showNewFavoritesInput = false"  v-if="showNewFavoritesInput" type="text" class="dialog-input" v-model.trim="newFavoritesInput" @keypress.enter="onNewFavorites()"/>
        <div v-for="(item, index) in folderNames" :key="index">
          <div class="row folder-name" :class="{'selected-folder-name': folder === item.name}" @click="onFolderNameClick(item.name)">
            <div>{{item.name}}</div>
            <img v-if="folder === item.name" src="../assets/img/check-number.svg" alt="">
          </div>
        </div>
      </div>
      <span slot="footer" class="row dialog-footer">
        <el-button class="btn new-favorites-btn" @click="onDialogNewFavorites">新建收藏夹</el-button>
        <div>
          <el-button class="btn cancel-btn" @click="onDialogCancel">取消</el-button>
          <el-button class="btn confirm-btn" @click="onDialogConfirm">提交</el-button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>
  
<script>
import authService from '@/services/authService';
import Pdf from '@/components/pdf-detail/Pdf';
import api from '@/rest/questionQuery';
import DetailSearchItem from '@/components/pdf-detail/DetailSearchItem';
import membersExpireDialog from '@/components/common/MembersExpireDialog';
import PdfFooter from '@/components/common/PdfFooter';

export default {
  name: 'PdfDetail',
  data() {
    return {
      keyWords: '',
      summaries: [],
      info: null,
      goToPage: 1,
      go: false,
      membersExpiredDialogVisible: false,
      collectDialogVisible: false,
      showNewFavoritesInput: false,
      newFavoritesInput: '',
      folderNames: [],
      folder: '',
      idArray: [],
      summariesArray: [],
      selectedOptionTab: 'text'
    };
  },
  methods: {
    onCollection() {
      if (this.selectedOptionTab === 'text') {
        this.collectDialogVisible = true;
        this.getFolderNames();
        this.idArray = [this.info.id];
        this.summariesArray = [this.info.text];
      } else if (this.selectedOptionTab === 'chart') {
        this.collectDialogVisible = true;
        this.getFolderNames();
        this.idArray = [this.info.id];
      }
    },
    onUncollect() {
      if (this.selectedOptionTab === 'text') {
        this.idArray = [this.info.id];
        api.uncollectPdf(this.idArray).then(() => {
          this.info.collected = false;
        });
      } else if (this.selectedOptionTab === 'chart') {
        this.idArray = [this.info.id];
        api.uncollectFigure(this.idArray).then(() => {
          this.info.collected = false;
        }); 
      }
    },
    onFolderNameClick(res) {
      this.folder = res;
    },
    onDialogNewFavorites() {
      this.newFavoritesInput = '';
      this.showNewFavoritesInput = true;
      this.$nextTick(() => {
        this.$refs.input.focus();
      });
    },
    onDialogCancel() {
      this.collectDialogVisible = false;
      this.showNewFavoritesInput = false;
      this.newFavoritesInput = '';
      this.folder = '';
      this.folderNames = [];
    },
    getFolderNames() {
      api.getDisplay().then(res => {
        this.folderNames = res.folderNames;
      });
    },
    onDialogConfirm() {
      if (this.selectedOptionTab === 'text') {
        api.collectPdf(this.idArray, this.info.highlight, this.summariesArray, this.folder).then(() => {
          this.info.collected = true;
        });
      } else if (this.selectedOptionTab === 'chart') {
        api.collectFigure(this.idArray, this.info.highlight, this.folder).then(() => {
          this.info.collected = true;
        });
      }
      this.collectDialogVisible = false;
    },
    onNewFavorites() {
      if (!this.newFavoritesInput) {
        this.$message({
          message: '文件夹名称不能为空',
          duration: 1000,
          type: 'error'
        });
      } else if (this.folderNames.some(item => item.name === this.newFavoritesInput)) {
        this.$message({
          message: '文件夹名称重复',
          duration: 1000,
          type: 'error'
        });
      } else {
        this.showNewFavoritesInput = false;
        this.folderNames.unshift({ name: this.newFavoritesInput });
      }
    },
    goToPdfPage(page) {
      // 工具函数 - 跳转到 pdf 某一页
      this.goToPage = page;
      this.$nextTick(() => {
        this.go = !this.go;
      });
    },
    download() {
      // 下载 pdf
      let link = this.info.link.indexOf('?') === -1 ? this.info.link : this.info.link.replace(/\?/, '%3F');
      api.getPdfDownload(link, this.info.title).then(() => {
        
      }, err => {
        if (err.status === 403) {
          this.membersExpiredDialogVisible = true;
        }
      });
    },
    pdfInitReady() {
      // pdf 实例初始化完成，跳转到指定页码位置
      // （当且仅当 info.page 字段不为空，也就是从图片搜素跳转过来详情页才会有 info.page 字段）
      // this.info.page = 3
      // ⬆️ 上一行为测试用代码
      if (this.info && this.info.figure_page && this.info.figure_page - 0) {
        this.goToPdfPage(this.info.figure_page - 0);
      }
    }
  },
  created() {
    // 页面 created 的时候从主页拿到详细数据
    this.info = JSON.parse(authService.getPdfDetailData());
    console.log(this.info);
    this.keyWords = this.info.keywords;
    document.title = this.info.title;
    if ('category' in this.info) {
      if (this.info.category === 'pdf') {
        this.selectedOptionTab = 'text';
      } else if (this.info.category === 'figure') {
        this.selectedOptionTab = 'chart';
      }
    } else if ('text' in this.info) {
      this.selectedOptionTab = 'text';
    } else {
      this.selectedOptionTab = 'chart';
    }
  },
  components: {
    Pdf,
    DetailSearchItem,
    membersExpireDialog,
    PdfFooter
  }
};
</script>
  
<style lang="scss" scoped>
.container {
  flex-direction: column;
  align-items: center;
  width: 100%;
  min-width: 1200px;
  height: 100%;
  box-sizing: border-box;
  background-color: #42414e;
  overflow: auto;
  .nav {
    justify-content: space-between;
    align-items: center;
    padding: 8px 80px;
    height: 40px;
    width: 100%;
    box-sizing: border-box;
    background-color: #5d5c68;
    flex-shrink: 0;
    .title {
      flex-shrink: 0;
      color: #ffffff;
      min-width: 10px;
      overflow:hidden;
      text-overflow:ellipsis;
      white-space:nowrap;
    }
    .oporation {
      align-items: center;
      width: 132px;
      .time {
        flex-shrink: 0;
        color: #ffffff;
      }
      .download {
        flex-shrink: 0;
        margin-left: 16px;
        width: 14px;
        height: 14px;
        background: url('../assets/img/download-fff.svg') center center;
        cursor: pointer;
        &:hover {
          background: url('../assets/img/download-hover.svg') center center;
        }
      }
      .collection-img {
        flex-shrink: 0;
        margin-left: 16px;
        width: 14px;
        height: 14px;
        background: url("../assets/img/collection-fff.svg") no-repeat;
        background-size: cover;
        cursor: pointer;
        &:hover {
          background: url("../assets/img/collection-hover.svg") no-repeat;
        }
      }
      .collected-img {
        flex-shrink: 0;
        margin-left: 16px;
        width: 14px;
        height: 14px;
        background: url("../assets/img/collected.svg") no-repeat;
        background-size: cover;
        cursor: pointer;
      }
    }
  }
  .main {
    justify-content: space-between;
    padding: 16px 0;
    margin: 0 auto;
    width: 1200px;
    min-height: 632px;
    height: 100%;
    min-width: 1200px;
    box-sizing: border-box;
    overflow: hidden;
    .pdf {
      margin: 0 auto;
      width: 814px;
      min-height: 600px;
      height: 100%;
      background-color: #fff;
    }
    .right {
      width: 378px;
      min-height: 600px;
      height: 100%;
      background-color: #fff;
      .search-nav {
        padding: 12px 16px;
        justify-content: start;
        flex-wrap: wrap;
        align-items: center;
        min-height: 48px;
        box-shadow: inset 0px -1px 0px 0px #f2f3f7;
        box-sizing: border-box;
      }
      .search-items {
        padding: 16px;
        width: 102%;
        height: calc(100% - 48px);
        box-sizing: border-box;
        overflow: scroll;
        .item-container {
          padding: 10px 0;
          border-bottom: 1px dotted #e5e6ee;
        }
      }
    }
  }
}

/deep/.collect-dialog {
  .dialog-content {
    overflow-y: auto;
    max-height: 160px;
  }
  .el-dialog {
    box-shadow: 0px 6px 10px 0px rgba(10, 31, 68, 0.1);
    border-radius: 2px;
    border: solid 1px #f7f7fa;
    .el-dialog__header {
      padding: 24px 24px 14px;
      .el-dialog__title {
        font-size: 16px;
      }
    }
    .el-dialog__body {
      max-height: 300px;
      overflow: auto;
      padding: 0 24px 16px;
    }
    .el-dialog__footer {
      padding: 0 24px 24px;
    }
  }
}
.dialog-input {
  width: 352px;
  height: 32px;
  padding-left: 16px;
  border-radius: 2px;
  border: solid 1px #e5e6ee;
  color: #171f46;
  outline: none;
  &:hover {
    border: solid 1px #999ebe;
  }

  &:focus {
    border: solid 1px #171f46;
  }
}
.folder-name {
  justify-content: space-between;
  margin-top: 10px;
  padding: 0 16px;
  width: 352px;
  height: 32px;
  line-height: 32px;
  color: #747990;
  background-color: rgba(0, 11, 92, 0.03);
  border-radius: 2px;
  font-size: 12px;
  cursor: pointer;
  &:hover {
    color: #171f46;
    background-color: rgba(0, 11, 92, 0.06);
  }
}
.selected-folder-name {
  color: #171f46;
  background-color: rgba(0, 11, 92, 0.06);
}
.dialog-footer {
  justify-content: space-between;
  .btn {
    height: 32px;
    padding: 0;
    border-radius: 2px;
    border: none;
    font-size: 14px;
  }
  .new-favorites-btn {
    width: 102px;
    color: #747990;
    background-color: rgba(0, 11, 92, 0.03);
    &:hover {
      color: #171f46;
      background-image: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)), linear-gradient(rgba(0, 11, 92, 0.03), rgba(0, 11, 92, 0.03));
      background-blend-mode: normal, normal;
    }
    &:focus {
      color: #171f46;
      background-image: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)), linear-gradient(rgba(0, 11, 92, 0.03), rgba(0, 11, 92, 0.03));
      background-blend-mode: normal, normal;
    }
    &:active {
      color: #171f46;
      background-image: linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), linear-gradient(rgba(0, 11, 92, 0.03), rgba(0, 11, 92, 0.03));
    background-blend-mode: normal, normal;
    }
  }
  .cancel-btn {
    width: 60px;
    color: #171f46;
    background-color: rgba(0, 11, 92, 0.03);
    &:hover {
      color: #171f46;
      background-image: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)), linear-gradient(rgba(0, 11, 92, 0.03), rgba(0, 11, 92, 0.03));
      background-blend-mode: normal, normal;
    }
    &:focus {
      color: #171f46;
      background-image: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)), linear-gradient(rgba(0, 11, 92, 0.03), rgba(0, 11, 92, 0.03));
      background-blend-mode: normal, normal;
    }
    &:active {
      color: #171f46;
      background-image: linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), linear-gradient(rgba(0, 11, 92, 0.03), rgba(0, 11, 92, 0.03));
      background-blend-mode: normal, normal;
    }
  }
  .confirm-btn {
    width: 60px;
    color: #ffffff;
    background-color: #0055ff;
    &:hover {
      color: #ffffff;
      background-image: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)), linear-gradient(#0055ff, #0055ff);
      background-blend-mode: normal, normal;
    }
    &:focus {
      color: #ffffff;
      background-image: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)), linear-gradient(#0055ff, #0055ff);
      background-blend-mode: normal, normal;
    }
    &:active {
      color: #ffffff;
      background-image: linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), linear-gradient(#0055ff, #0055ff);
      background-blend-mode: normal, normal;
    }
  }
}
</style>
